import { Updater, AsyncState, loadingAsyncState } from 'widgets-for-react'
import { initialPaginationState, PaginationState } from '../pagination/paginationState'
import { filtersToQueryParams, NewsAndEventsFilters } from '../../utils/filtersToQueryParams'
import { newsAndEventsOverviewApi } from './newsAndEventsOverviewApi'
import { NewsOrEvent } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockState'

export type NewsAndEventsOverviewState = {
  paginationState: PaginationState
  newsAndEventsItemsState: AsyncState<NewsOrEvent[]>
}

export const initialNewsAndEventsOverviewState = (
  page: number,
  tags?: string[],
  department?: string,
  subDepartment?: string,
  specialist?: string,
  centrum?: string,
  subcentra?: string
): NewsAndEventsOverviewState => {
  const filters: NewsAndEventsFilters = {
    tags: tags,
    department: department,
    subDepartment: subDepartment,
    specialist: specialist,
    centrum: centrum,
    subcentra: subcentra
  }

  const shouldContainExcludedTags = (filters.tags?.includes("Hoor Floor") || filters.tags?.includes("Inspiratie")) ? true : false
  return {
    paginationState: initialPaginationState(
      `/api/v1/pages/newsandevents/count/filter?${filtersToQueryParams(filters)}&shouldContainExcludedTags=${shouldContainExcludedTags}`
    ),
    newsAndEventsItemsState: loadingAsyncState(() => newsAndEventsOverviewApi(filters, page)),
  }
}

export const newsAndEventsOverviewStateUpdaters = {
  updateNewsAndEventsCountState:
    (updater: Updater<AsyncState<number>>) =>
    (currentState: NewsAndEventsOverviewState): NewsAndEventsOverviewState => ({
      ...currentState,
      paginationState: updater(currentState.paginationState),
    }),
  updateNewsAndEventsItemsState:
    (updater: Updater<AsyncState<NewsOrEvent[]>>) =>
    (currentState: NewsAndEventsOverviewState): NewsAndEventsOverviewState => ({
      ...currentState,
      newsAndEventsItemsState: updater(currentState.newsAndEventsItemsState),
    }),
}
